export default __webpack_public_path__ + "static/media/CustomerJourney.a822d1d5.svg";